// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MuiTimepicker from 'components/__v2__/MuiTimepicker/Timepicker';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { formatDate, parseWithFormat } from 'utils/dateUtils';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import ClearSelection from '../components/ClearSelection';

const TimeFormFieldPreview = ({
  element,
  answer,
  handleDirty,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const [timeValue, setTimeValue] = useState(
    answer && answer !== '' ? parseWithFormat(answer, 'HH:mm') : null,
  );
  const [, { setAnswer }] = useCustomForm();

  const handleChange = (value) => {
    if (value) {
      const formattedTime = formatDate(value, 'HH:mm');
      setTimeValue(value);
      setAnswer(element?.id, formattedTime);
      if (updateAnswerInPrefilledElements) {
        updateAnswerInPrefilledElements(
          element?.id,
          formattedTime,
          element?.type,
        );
      }
    } else {
      setTimeValue(null);
      setAnswer(element?.id, '');
      if (updateAnswerInPrefilledElements) {
        updateAnswerInPrefilledElements(element?.id, '', element?.type);
      }
    }
    handleDirty();
  };

  const handleClearSelection = () => {
    setTimeValue(null);
    setAnswer(element?.id, '');
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(element?.id, '', element?.type);
    }
    handleDirty();
  };

  useEffect(() => {
    setTimeValue(
      answer && answer !== '' ? parseWithFormat(answer, 'HH:mm') : null,
    );
  }, [answer]);

  return (
    <div>
      <Box key={element?.id} m={1}>
        <FieldsInputTitle
          label={element?.label || element?.name}
          isRequired={element?.isRequired}
        />
        <Box width={400}>
          <MuiTimepicker
            value={timeValue}
            onChange={(value) => handleChange(value)}
            placeholder="Choose your time"
            disabled={shouldBeReadOnly}
          />
        </Box>
        {!element?.isRequired && timeValue && !shouldBeReadOnly && (
          <ClearSelection handleClear={handleClearSelection} />
        )}
      </Box>
    </div>
  );
};

export default TimeFormFieldPreview;
